export default __webpack_public_path__ + "img/d28f16a8cfd7c0d672199e0c87ec8a27.svg";